import { render, staticRenderFns } from "./twitter-share.vue?vue&type=template&id=d753de1c"
import script from "./twitter-share.vue?vue&type=script&lang=js"
export * from "./twitter-share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports